import React from "react";
import { isProduction } from "../../common/utils";

const DebugMode = () => {
  if (!isProduction) {
    // 正式環境不輸出 debug 訊息
    localStorage.removeItem("debug");
    console.log = () => {};
  } else {
    // 輸出所有類型的 debug
    localStorage.debug = "*";
  }
  return null;
};

export default DebugMode;
